import React, { Component } from "react";

import { Field, Form, Formik } from "formik";

import { FormGroup, Label, Button } from "reactstrap";

import { isEmpty } from "lodash";

import { SimpleInput, DefaultObject, SelectInput } from "@gsd/backoffice-ui";

import * as Yup from "yup";

const ValidateSchema = Yup.object().shape({
  label: Yup.string().required("Campo obbligatorio"),
  value: Yup.string().required("Campo obbligatorio"),
});

type FormProps = {
  onSubmit: Function;
  initialValues: {
    uid: number;
    applicationUid: number;
    label: string;
    value: string;
    description: string;
  };
  applicationOpts: Array<unknown>;
};

export default class FormAcl extends Component<FormProps> {
  static defaultProps: Partial<FormProps> = {
    onSubmit: (values) => {
      console.log(values);
    },
  };

  render() {
    const { initialValues, applicationOpts } = this.props;
    if (isEmpty(initialValues)) return null;
    const defaultValues = {
      uid: 0,
      label: "",
      value: "",
      description: "",
    };

    const formValues = DefaultObject(initialValues, defaultValues);

    return (
      <Formik
        initialValues={formValues}
        validationSchema={ValidateSchema}
        validateOnBlur
        isInitialValid={true}
        onSubmit={this.props.onSubmit as any}
      >
        {(formmikProps) => {
          return (
            <Form>
              <input type="hidden" value={0} name="uid" />
              <FormGroup>
                <Label for="applicationUid">Applicazione Associata</Label>
                <Field
                  name="applicationUid"
                  options={applicationOpts}
                  component={SelectInput}
                />
              </FormGroup>
              <FormGroup>
                <Label for="label">
                  Nome
                  <span className="text-primary">*</span>
                </Label>
                <Field name="label" type={"text"} component={SimpleInput} />
              </FormGroup>
              <FormGroup>
                <Label for="value">
                  Descrizione ruolo
                  <span className="text-primary">*</span>
                </Label>
                <Field name="value" type={"text"} component={SimpleInput} />
              </FormGroup>
              <FormGroup>
                <Label for="description">Suffisso </Label>
                <Field
                  name="description"
                  type={"text"}
                  component={SimpleInput}
                />
              </FormGroup>
              <div className="text-center">
                <Button
                  color="primary"
                  size="lg"
                  className="px-5"
                  type="submit"
                  disabled={!formmikProps.isValid || formmikProps.isSubmitting}
                >
                  Salva
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    );
  }
}
